






















import Vue from 'vue';

export default Vue.extend({
  name: 'AddPageMedia',
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      image: null,
    };
  },
  methods: {
    onConfirm() {
      this.$parent.$emit('addPageMedia', this.image);
      this.$emit('close');
    },
  },
});
